import React from 'react';
import { observer } from "mobx-react"
import {toJS} from 'mobx';
import ewtStore from '../EWTStore';
import { theme, ewtModalClass, modalStyle } from '../theme';
import {Modal,Button} from 'antd';
import {PlusSquareFilled,MinusSquareFilled} from '@ant-design/icons';


const CorrectScore = observer(class CorrectScore extends React.Component {
	constructor(props) {
		super(props);
		this.state = {newScore:!ewtStore.correctScore.score?4:ewtStore.correctScore.score}
		this.updateScore = this.updateScore.bind(this);
		this.deleteScore = this.deleteScore.bind(this);
	}

	deleteScore() {
		ewtStore.deleteScore(ewtStore.correctScore);
		ewtStore.correctScore = null;
	}
	updateScore() {
		var hole = ewtStore.correctScore;
		var score = this.state.newScore;
		ewtStore.setScore(hole.roundID,hole.playerID,hole.num,score);
		ewtStore.correctScore = null;
	}


	render() {
		var hole = ewtStore.correctScore;
		console.dir(toJS(hole));
		return (
			<Modal
				className={ewtModalClass}
				title="Correct Score"
				open={true}
				onCancel={() => ewtStore.correctScore = null}
				bodyStyle={{ margin: 0, padding: 16 }}
				style={modalStyle}
				closable={true}
				footer={null}
				>
				<div className="flexColumn flexGrow" style={{ fontSize: 20, gap: 8, color: theme.navy }}>
					<div className="flexRow">Player&nbsp;<b>{ewtStore.players[hole.playerID].first_name}&nbsp;{ewtStore.players[hole.playerID].last_name}</b></div>
					<div className="flexRow">Round&nbsp;<b>{ewtStore.rounds[hole.roundID].desc}</b></div>
					<div className="flexRow">Hole&nbsp;<b>{hole.num}</b></div>
					<div className="flexRow">Current Score&nbsp;<b>{hole.score}</b></div>
					<div className="flexRow" style={{ alignItems: 'center' }}>
						<div style={{ marginTop: 4 }}>New Score&nbsp;</div>
						<div style={{ width: 40, fontSize: 38, padding: 5, cursor: 'pointer', color: theme.brandBlue }} onClick={() => this.setState({newScore:this.state.newScore===1?1:this.state.newScore-1})}><MinusSquareFilled></MinusSquareFilled></div>
						<div style={{ marginTop: 4 }}>&nbsp;&nbsp;<b>{this.state.newScore}</b>&nbsp;</div>
						<div style={{ width: 40, fontSize: 38, padding: 5, cursor: 'pointer', color: theme.brandBlue }} onClick={() => this.setState({newScore:this.state.newScore+1})}><PlusSquareFilled></PlusSquareFilled></div>
					</div>
					<div className="flexRow" style={{ marginTop: 20, gap: 10, flexWrap: 'wrap' }}>
						<Button onClick={() => this.updateScore()} type="primary">Make Change</Button>
						<Button onClick={() => ewtStore.correctScore = null}>Cancel</Button>
						<Button onClick={() => this.deleteScore()} danger>Delete Score</Button>
					</div>
				</div>
			</Modal>
	  	);
	}
});


export default CorrectScore;